import React from 'react';
import '@trp-beacon-ui-kit/foundation/style-tokens/css/variables.css';
import '@trp-beacon-ui-kit/foundation/fonts/fonts.css';
import { Box } from '@mui/material';
import { Typography } from '@trp-individual-investor-adv-svc/ii-prosp-components';

import { dispatchOverlayLoad } from './shared/Analytics';
import { transferPage } from './shared/Links';
import HubPageBase from './HubPages/HubPageBase';
import { PsBeaconButton, PsBeaconIcon } from './shared/BeaconRegister';

const MonitorLandingPage = ({ state, dispatch }) => {

    const [buttonSize, setButtonSize] = React.useState(window.innerWidth <= 600 ? '100%' : 'inherit');
    const smallScreenSize = window.matchMedia("(max-width: 600px)");

    smallScreenSize.addEventListener('change', function () {
        setButtonSize(smallScreenSize.matches ? '100%' : 'inherit')
    });

    const openEducationModal = () => {
        const educationModal = document.querySelector('#education-modal');
        if (educationModal !== null) {
            educationModal.show();
            dispatchOverlayLoad('Education Overlay');
        }
    };

    return (
        <HubPageBase state={state} dispatch={dispatch}>
            <Box
                id="monitor-page-content-container"
                className="b-container-content"
                sx={{ inlineSize: 'unset !important' }}>
                <Typography
                    id="monitor-page-title"
                    type="headline" serif loose scale={400}
                    sx={{ paddingTop: '64px', paddingBottom: '48px' }}>
                    Keep your service up to date
                </Typography>
                <Box
                    id="monitor-page-transfer-content-container"
                    sx={{ paddingBottom: '72px' }}>
                    <Typography
                        id="monitor-page-transfer-title"
                        type="headline" scale={100} bold
                        sx={{ paddingBottom: '16px' }}>
                        Transfer new accounts
                    </Typography>
                    <Typography
                        id="monitor-page-transfer-content-description"
                        loose
                        light
                        sx={{ paddingBottom: '24px' }}>
                        Provide external account numbers and additional transfer details for the
                        accounts you identified while reviewing your investment proposal.
                    </Typography>
                    <Box id="transfer-external-accounts-button">
                        <PsBeaconButton
                            scale="jumbo"
                            href={transferPage}
                            link-target="_blank"
                            style={{ whiteSpace: 'nowrap', width: buttonSize }}>
                            Transfer External Accounts{' '}
                            <PsBeaconIcon
                                style={{ paddingTop: '2px' }}
                                name="chevron_right"
                                slot="suffix"
                                alt="arrow-forward-icon"
                            />
                        </PsBeaconButton>
                    </Box>
                </Box>
                <Box
                    id="monitor-page-update-questionnaire-content-container"
                    sx={{ paddingBottom: '72px' }}>
                    <Typography
                        id="monitor-page-transfer-title"
                        type="headline" scale={100} bold
                        sx={{ paddingBottom: '16px' }}>
                        Update questionnaire or schedule a check-in
                    </Typography>
                    <Typography
                        id="monitor-page-update-questionnaire-content-description"
                        loose
                        light
                        sx={{ paddingBottom: '24px' }}>
                        Review your questionnaire and personal information to ensure your
                        account aligns to your current situation. You will also be prompted to
                        set up a conversation with your financial advisor.
                    </Typography>
                    <Box id="update-questionnaire-button">
                        <PsBeaconButton
                            scale="jumbo"
                            onClick={openEducationModal}
                            variant="secondary"
                            style={{ whiteSpace: 'nowrap', width: buttonSize }}>
                            Review Your Questionnaire{' '}
                            <PsBeaconIcon
                                style={{ paddingTop: '2px' }}
                                name="chevron_right"
                                slot="suffix"
                                alt="arrow-forward-icon"
                            />
                        </PsBeaconButton>
                    </Box>
                </Box>
                <Box
                    id="monitor-page-update-questionnaire-content-container"
                    sx={{ paddingBottom: '72px' }}>
                    <Typography
                        id="monitor-page-transfer-title"
                        type="headline" scale={100} bold
                        sx={{ paddingBottom: '16px' }}>
                        Review your accounts
                    </Typography>
                    <Typography
                        id="monitor-page-update-questionnaire-content-description"
                        loose
                        light
                        sx={{ paddingBottom: '24px' }}>
                        Go to your retirement homepage to see a snapshot of your portfolio,
                        download statements, and see recent activity.
                    </Typography>
                    <Box id="update-questionnaire-button">
                        <PsBeaconButton
                            scale="jumbo"
                            onClick={() => window.location.replace('/usis/my-accounts/')}
                            variant="tertiary">
                            View Your Dashboard
                        </PsBeaconButton>
                    </Box>
                </Box>
            </Box>
        </HubPageBase>
    );
};

export default MonitorLandingPage;
